// src/components/PrivacyPolicy.js
// Legacy file — delegates to the canonical Termly-backed component.
import React from 'react';
import TermlyEmbed from './policies/TermlyEmbed';

const PrivacyPolicy = () => (
  <TermlyEmbed dataId="13d638fb-9167-4a7b-8b68-eb366e975d10" />
);

export default PrivacyPolicy;
